<template>
  <div class="hero-slider">
    <div class="swiper-container" ref="heroSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(image, index) in images" :key="index">
          <img :srcset="image" />
        </div>
        <div class="text-wrapper">
          <h1 v-html="settings.title"></h1>
          <p>{{ settings.text }}</p>
          <a
            :href="settings.button_link"
            v-if="settings.button_link && settings.button_label"
            >{{ settings.button_label }}</a
          >
        </div>
      </div>
    </div>
    <div class="swiper-button-prev" ref="prev"></div>
    <div class="swiper-button-next" ref="next"></div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";

export default {
  props: {
    images: { type: Array, required: true },
    settings: { type: Object, required: true },
  },
  mounted() {
    // init swiper
    const heroSwiper = new Swiper(this.$refs.heroSwiper, {
      slidesPerView: 1,
      watchOverflow: true,
      speed: 1000,
      autoplay: true,
      effect: "fade",
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.hero-slider {
  height: 100%;
  position: relative;

  .swiper-container {
    width: 100%;
    height: 100%;

    .swiper-slide {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 10;
        background-color: rgba(0, 0, 0, 0.2);
        opacity: 0;
      }
    }

    .swiper-slide-active {
      &.lazyloading {
        opacity: 0 !important;
        transition: opacity 200ms ease-in !important;
      }

      &.lazyloaded {
        opacity: 1 !important;
        transition: opacity 200ms ease-in !important;
        &::before {
          opacity: 1;
        }
      }
    }

    .text-wrapper {
      height: 100%;
      max-width: 580px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: $white;
      padding: 0 20px;

      h1 {
        font-size: 50px;
        font-weight: 400;
        letter-spacing: 3.33px;
        line-height: 60px;
        text-transform: uppercase;

        @include res(tab-p) {
          font-size: 35px;
          line-height: 40px;
          letter-spacing: 1px;
        }
      }

      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin: 10px 0 25px;

        @include res(tab-p) {
          font-size: 16px;
          margin: 10px 0 15px;
        }
      }

      a {
        @include button(#ffffff, 15px, 55px);
        border: 1px solid $white;
        text-transform: uppercase;
        align-self: center;

        @include res(tab-p) {
          width: 100%;
          @include button(#ffffff, 10px, 55px);
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 40px;
    height: 30px;
    background-size: contain;
    outline: none;
    top: 95%;
  }
  .swiper-button {
    &-prev {
      right: 50px;
      left: auto;
      transform: rotate(180deg);
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23969BA5'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      @include res(mobile) {
        display: none;
      }
    }
    &-next {
      right: 25px;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23969BA5'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      @include res(mobile) {
        display: none;
      }
    }
  }
}
</style>
